import React from 'react';

export default class Checkbox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isChecked: this.props.formData
        };
    }

    onChange(e) {}

    onClick() {
        this.setState({isChecked: !this.props.formData}, () => this.props.onChange(this.state.isChecked));
    }

    render() {
        return (
            <div>
                <input type="checkbox"
                       name={this.props.idSchema.$id}
                       value={this.props.name}
                       disabled={this.props.schema.locked !== undefined ? this.props.schema.locked : false}
                       checked={this.props.formData}
                       onChange={this.onChange.bind(this)}
                />
                <label htmlFor={this.props.idSchema.$id}
                       onClick={this.onClick.bind(this)}>{this.props.schema.title}</label>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/forms/fields/Checkbox.js